import { ChakraProvider } from "@chakra-ui/react";
import { BrowserRouter } from "react-router";
import theme from "theme";
import AllRoutes from "routes/AllRoutes";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import memoryColorModeManager from "theme/MemoryColorModeManager";
import "assets/application.css";
import { toastOptions } from "definitions/constants/config";
import { useRef } from "react";
import { FeatureProvider } from "contexts/FeatureContext";
import { initializeAnalytics } from "services/analytics";

const queryClient = new QueryClient();

// Initialize analytics
initializeAnalytics();

export default function App(): JSX.Element {
  // this ref is toasts appear in front of modals / all other elements - known bug with setting portalZIndex
  // where it causes the toast to be below the modals
  const ref = useRef<HTMLDivElement>(null);
  return (
    <BrowserRouter>
      <QueryClientProvider client={queryClient}>
        <ChakraProvider
          theme={theme}
          colorModeManager={memoryColorModeManager}
          toastOptions={{
            ...toastOptions,
            portalProps: {
              containerRef: ref,
            },
          }}
          portalZIndex={40}
        >
          <FeatureProvider>
            <AllRoutes />
            <div ref={ref} />
          </FeatureProvider>
        </ChakraProvider>
      </QueryClientProvider>
    </BrowserRouter>
  );
}
